import { useRef, useState } from 'react';

import locationLinkIcon from '@atom/images/location-link.svg';
import { IconButton, List, Popover } from '@atom/mui';
import { LocationLinkOption } from '@atom/types/map';

import classes from './locationLinkControls.module.css';

const { ListItemButton } = List;

type LocationLinkControlsProps = {
  canSyncWorkToInventory: boolean;
  canSyncInventoryToWork: boolean;
  onSyncWorkToInventory: () => void;
  onSyncInventoryToWork: () => void;
};

const LocationLinkControls = ({
  canSyncWorkToInventory,
  canSyncInventoryToWork,
  onSyncWorkToInventory,
  onSyncInventoryToWork,
}: LocationLinkControlsProps) => {
  const anchor = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const options: LocationLinkOption[] = [
    ...(canSyncWorkToInventory
      ? [
          {
            text: `Sync work to inventory's location`,
            onClick: onSyncWorkToInventory,
          },
        ]
      : []),
    ...(canSyncInventoryToWork
      ? [
          {
            text: `Sync inventory to work's location`,
            onClick: onSyncInventoryToWork,
          },
        ]
      : []),
  ];

  const handleSelect = (option: LocationLinkOption) => () => {
    setOpen(false);
    option.onClick();
  };

  if (options.length === 0) {
    return null;
  }

  return (
    <div
      className={classes.locationLinkControl}
      ref={anchor}
      data-cy="atomMapLocationLink"
    >
      <IconButton
        tooltip="Location Sync"
        onClick={() => setOpen(prev => !prev)}
      >
        <img src={locationLinkIcon} alt="" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchor.current}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        onClose={() => setOpen(false)}
      >
        <List>
          {options.map(option => (
            <ListItemButton key={option.text} onClick={handleSelect(option)}>
              {option.text}
            </ListItemButton>
          ))}
        </List>
      </Popover>
    </div>
  );
};

export default LocationLinkControls;
